import type { GatewayRanking } from 'commonTypes/api/gatewayRanking';
import { splitFullName } from 'commonUtils/formatters/splitFullName';
import { AMOUNTS } from 'constants/amounts';

import { lowercaseFirstLetter } from 'shared/lib';
import { calculateAgeFromDates, dateDiffMonths, toValidDate } from 'shared/lib/dates';
import type { TProductsRequestBody } from 'shared/types/TRankingService';

import type { TCreditFormCommonFields } from 'entities/creditForm';
import type { IOffersFiltersState } from 'entities/offersFilters';

import { parseWorkStartDate } from './parseWorkStartDate';

export const formDataToInitialDataBodyAdapter = (
  formData: TCreditFormCommonFields,
  filters: IOffersFiltersState['form'] & Pick<TProductsRequestBody['filters'], 'isFilterPreApprovals'>,
  partnerId: number | undefined,
  blockFF: GatewayRanking.RankingFeatureFlagsConfig | undefined,
  variant?: number,
): TProductsRequestBody => {
  const { lastName, firstName, middleName } = splitFullName(formData.fullName?.value?.toString() || '');
  const birthDate = toValidDate(formData.birthDate);

  return {
    blockFF,
    birthPlace: formData.birthPlace,
    homeAddress: formData.registrationAddress?.value,
    registrationAddress: formData.residenceAddress?.value,
    filters: {
      filterByAffId: partnerId,
      creditSecurityType: filters.creditSecurityType?.value || 'NoMatter',
      purpose: formData.purpose?.value || 'Money',
      isFilterPreApprovals: filters.isFilterPreApprovals || false,
    },
    partnerId: partnerId?.toString(),
    firstName,
    lastName,
    middleName,
    birthDate: formData.birthDate,
    age: calculateAgeFromDates(birthDate),
    // TODO разобраться, что это за свалка параметров
    // savedSearchId: 'string',
    // flowId: 'string',
    // initialAmount: 0,
    productTypes: filters.productTypes,
    // autoBrand: 'string',
    // autoBrandId: 'string',
    // autoModelId: 'string',
    // filteredOrganizationId: 'string',
    gender:
      formData.gender === 'Unknown'
        ? undefined
        : (String(formData.gender).toLowerCase() as TProductsRequestBody['gender']),
    amount: Number(formData.amount),
    locationRoute: formData.regionLocationRoute,
    registrationLocationRoute: formData.registrationLocationRoute,
    residentialLocationRoute: formData.residenceLocationRoute,
    workLocationRoute: formData.workLocationRoute,
    term: formData.period?.value,
    periodOfResidence: formData.registrationDate,
    monthlyIncome:
      formData.employmentType?.value === 'NotWorking' ? AMOUNTS.monthlySalaryMin : Number(formData.monthlySalary),
    employment: formData.employmentType?.value as TProductsRequestBody['employment'],
    jobType: lowercaseFirstLetter(formData.jobTitle?.data?.type),
    lastPlaceworkExperience: formData.lastWorkExperienceStartMonth
      ? dateDiffMonths(new Date(), parseWorkStartDate(formData.lastWorkExperienceStartMonth))
      : 0,
    solvencyProof: 'Ndfl2',
    education: formData.education?.value as TProductsRequestBody['education'],
    inn: formData.employerInn,
    flatNumber: Number(formData.residenceAddressFlat),
    areaOfEmployment: formData.areaOfEmployment?.value.toString(),
    email: formData.email,
    opf: formData.employerType?.value as TProductsRequestBody['opf'],
    customerProperty: formData.propertyTypeAvailability?.value as TProductsRequestBody['customerProperty'],
    maritalStatus: formData.maritalStatus?.value as TProductsRequestBody['maritalStatus'],
    dependents: formData.numberOfDependents?.value as TProductsRequestBody['dependents'],
    carManufacturer: formData.carAvailability?.value as TProductsRequestBody['carManufacturer'],
    additionalPhoneOwner: formData.additionalPhoneOwner?.label as TProductsRequestBody['additionalPhoneOwner'],
    snils: formData.snils,
    phone: formData.mobilePhone,
    purpose: formData.purpose?.value.toString(),
    passportSeriesNumber: formData.passportNumber,
    passportIssuerCode: formData.unitCode,
    passportIssuedBy: formData.passportIssuedBy,
    passportIssueDate: formData.passportIssueDate,
    ...(formData.okved ? { okved: formData.okved } : {}),
    // TODO разобраться, что это за свалка параметров
    // hasDelinquency: true,
    // ignoreScoringByType: 'string',
    // ignoreScoringByIds: ['string'],
    // utilization: true,
    // callcenter: 'string',
    // utmMedium: 'string',
    // organizationsLastRequestDates: 'string',
    // requestStatuses: ['string'],
    page: 'landing',
    variant: variant || 1,
    loanIssuanceRegion: formData.region?.value || '',
  };
};
